import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment'
import {User} from '../models/user'
import { catchError } from "rxjs/operators";
import { AgoraConfigService } from "src/AgoraConfigService";

@Injectable({ providedIn: 'root' })
export class ReportService {
  
  httpHeaders:any;
  agoraConfigObject: any;
  
  constructor(private http: HttpClient, private agoraConfig: AgoraConfigService) {
		this.agoraConfigObject = this.agoraConfig.getConfig().endpoints;
    this.httpHeaders = new HttpHeaders().set('Content-Type', 'application/json;charset=utf-8').set("Access-Control-Allow-Origin", "*")
    .set("Access-Control-Allow-Headers", "*")
    .set("Access-Control-Allow-Methods", "GET,POST,PUT,DELETE");
  }

  downloadReport(dateRangeStart:any, dateRangeEnd:any,facilitatorId:number, meetingStatus:string){
      return this.http.get(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.report}/`+'downloadReport?meetingFromDate=' + dateRangeStart + '&meetingToDate=' + dateRangeEnd+'&facilitatorId='+facilitatorId+'&meetingStatus='+meetingStatus, { responseType: 'blob', headers: this.httpHeaders })
  }
  loadUsers(){
    return this.http.get<User[]>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.user}`+'getAllUsers',{headers: this.httpHeaders});
  }
  getMeetingCount(dateRangeStart:any, dateRangeEnd:any,facilitatorId:number, meetingStatus:string){
    return this.http.get(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.report}/`+'countMeetings?meetingFromDate=' + dateRangeStart + '&meetingToDate=' + dateRangeEnd+'&facilitatorId='+facilitatorId+'&meetingStatus='+meetingStatus,{headers: this.httpHeaders});
  }
  getAllReports(param:any){
      return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.report}/`+'getReports',param,{ headers: this.httpHeaders,observe: 'response'});
  }
  getFilter(param:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.report}/`+'getFilter',param,{ headers: this.httpHeaders,observe: 'response'});
  }
  exportReport(param:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.report}/`+'exportReport',param,{ headers: this.httpHeaders,observe: 'response'});
  }
getDrilldownData(param:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.report}/`+'drillDownData',param,{ headers: this.httpHeaders,observe: 'response'});
    // return this.http.post<any>("http://192.168.193.47:1999/report/drillDownData",param,{ headers: this.httpHeaders,observe: 'response'});

  }
  getPhemeReportData(param:any){
    return this.http.post<any>(`${this.agoraConfig.getConfig().apiBaseUrl}${this.agoraConfigObject.report}/`+'phemeGetReport',param,{ headers: this.httpHeaders,observe: 'response'});
      // return this.http.post<any>("http://192.168.193.47:1999/report/phemeGetReport",param,{ headers: this.httpHeaders,observe: 'response'});

  }
}
